import { ITEM_KINDS, STATES } from '../../../constants';

const TITLE = 'Your Local Guide';

export function RecommendedProvidersConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_RECOMMENDED_PROVIDERS, {
    url: '/recommended-providers',
    views: {
      '@': {
        template: '<upd-recommended-providers></upd-recommended-providers>',
      },
    },
    scrollTop: true,
    title: TITLE,
    titleBar: {
      title: TITLE,
      icon: 'storefront',
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.RECOMMENDED_PROVIDER,
        singleton: true,
      },
    },
  });
}
